import moment from 'moment'

const formatDate = (date, dateFormat = 'DD/MM/YYYY') => moment(date).format(dateFormat)

export default formatDate
